import returnIconSrc from '../../assets/icons/orderStatusIcons/return.png'
import GenericIcon from './GenericIcon'

const ReturnIcon = ({ className }) => {
  return <GenericIcon src={returnIconSrc} alt="Return Icon" className={className} />
}

export default ReturnIcon
